import { render, staticRenderFns } from "./LiveStream.vue?vue&type=template&id=bf2299a2&"
import script from "./LiveStream.vue?vue&type=script&lang=js&"
export * from "./LiveStream.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports